import { render, staticRenderFns } from "./PaymentRecordImageHeader.vue?vue&type=template&id=3b524026&scoped=true&"
import script from "./PaymentRecordImageHeader.vue?vue&type=script&lang=js&"
export * from "./PaymentRecordImageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRecordImageHeader.vue?vue&type=style&index=0&id=3b524026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b524026",
  null
  
)

export default component.exports